export default __webpack_public_path__ + "static/media/blog-img71.7f5f2755.jpg";